import { useContext, useEffect, useRef } from 'react'
import { BreadcrumbOverridesContext } from '@/components/layout/breadcrumb-overrides-context'

export function useOverrides() {
  return useContext(BreadcrumbOverridesContext).overrides
}

/**
 * Register a breadcrumb label override for a dynamic URL segment (e.g. a UUID).
 * The override is automatically cleaned up when the component unmounts.
 */
export function useBreadcrumbLabel(segment: string | undefined, label: string | undefined) {
  const { set, remove } = useContext(BreadcrumbOverridesContext)
  const prevSegment = useRef<string | undefined>(undefined)

  useEffect(() => {
    if (prevSegment.current && prevSegment.current !== segment) {
      remove(prevSegment.current)
    }
    prevSegment.current = segment

    if (segment && label) {
      set(segment, label)
    }

    return () => {
      if (segment) remove(segment)
    }
  }, [segment, label, set, remove])
}
